import axios from "axios";
import { serialize } from "@/utils";
import { getStore } from "@/utils/store";
import NProgress from "nprogress";
import { Message, MessageBox } from "element-ui";
import "nprogress/nprogress.css";
import qs from "qs";
import store from "@/store";

// 通用配置
const commonConfig = {
  timeout: 60000,
  withCredentials: true,
  validateStatus(status) {
    return status >= 200 && status < 500;
  }
};

// 创建 loginReq 实例
const loginReqInstance = axios.create({
  ...commonConfig,
  baseURL: "",
});

// 创建 shopInfo 实例
const shopInfoInstance = axios.create({
  ...commonConfig,
  baseURL: "",
  headers: {
    "Content-Type": "	application/json;charset=UTF-8",
  },
});

// NProgress 配置
NProgress.configure({
  showSpinner: false,
});

// 通用请求拦截器
const requestInterceptor = (config) => {
  const TENANT_ID = getStore({ name: "tenantId" }) || '';
  const USER_ID = getStore({ name: "userId" }) || '';
  const isToken = (config.headers || {}).isToken === false;
  const token = store.getters.access_token;

  if (token && !isToken) {
    config.headers["Authorization"] = "Bearer " + token; // token
  }
  if (TENANT_ID) {
    config.headers["x-tenantId"] = TENANT_ID; // 租户ID
  }
  if (USER_ID) {
    config.headers["x-userId"] = USER_ID; // 用户ID
  }

  // headers中配置serialize为true开启序列化
  if (config.method === "post" && config.headers.serialize) {
    config.data = serialize(config.data);
    delete config.data.serialize;
  }
  if (config.method === "get") {
    config.paramsSerializer = function (params) {
      return qs.stringify(params, { arrayFormat: "repeat" });
    };
  }
  return config;
};

// 通用响应拦截器
const responseInterceptor = (res) => {
  const config = res.config;
  NProgress.done();
  const status = Number(res.status) || 200;
  let message = "";
  if(res.data.msg) {
    message = res.data.msg || "未知错误";
  } else if (res.data.message) {
    message = res.data.message || "未知错误";
  }

  // 后台定义 424 针对令牌过期的特殊响应码
  if (status === 424) {
    MessageBox.confirm("令牌状态已过期，请点击重新登录", "系统提示", {
      confirmButtonText: "重新登录",
      type: "warning",
      showClose: false,
      showCancelButton: false,
      closeOnPressEscape: false,
      closeOnClickModal: false,
    }).then(() => {
      store.dispatch("LogOut").then(() => {
        // 刷新登录页面，避免多次弹框
        window.location.reload(true);
      });
    });
    return;
  }

  if (status !== 200 || (res.data.code && res.data.code !== 0)) {
    // 不处理响应内容
    if (config.notProcessResponse) {
      return Promise.reject(res.data);
    }
    let jsonMsg = JSON.stringify(message);
    if (jsonMsg.includes("\\n")) {
      jsonMsg = jsonMsg.replace(/\\n/g, "<br>");
      jsonMsg = jsonMsg.replace(/"/g, "");
      Message({
        message: jsonMsg,
        dangerouslyUseHTMLString: true,
        type: "error",
      });
      return Promise.reject(new Error(jsonMsg));
    } else {
      Message({
        message: message,
        type: "error",
      });
      return Promise.reject(new Error(message));
    }
  }

  return res;
};

// 通用错误拦截器
const errorInterceptor = (error) => {
  // 处理 503 网络异常
  if (error && error.response && error.response.status === 503) {
    Message({
      message: "网络错误,请稍后再试",
      type: "error",
    });
  }
  NProgress.done();
  return Promise.reject(new Error(error));
};

// 为 loginReqInstance 添加拦截器
loginReqInstance.interceptors.request.use(requestInterceptor, (error) =>
  Promise.reject(error)
);
loginReqInstance.interceptors.response.use(responseInterceptor, errorInterceptor);

// 为 shopInfoInstance 添加拦截器
shopInfoInstance.interceptors.request.use(requestInterceptor, (error) =>
  Promise.reject(error)
);
shopInfoInstance.interceptors.response.use(responseInterceptor, errorInterceptor);

// 处理结果函数
export function processResult(val, key = "data") {
  const data = val.data;
  return data[key] !== undefined ? data[key] : data;
}

export { loginReqInstance as loginReq, shopInfoInstance as shopInfo };
